
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.538 8.147L7.245 2.855a1.049 1.049 0 00-1.485 0c-.41.41-.41 1.075 0 1.486l3.808 3.806-3.808 3.808a1.047 1.047 0 000 1.484c.41.41 1.076.41 1.485 0l5.293-5.292"}})])
          )
        }
      }
    